import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_DASHBOARD_CONTACT_DM = defineFcm('starter_dashboard_contact_dm')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				emailEnabled: { type: 'boolean' },
				emailSubjectLine: { type: 'string', optional: true },
				emailBody: { type: 'array', optional: true, shape: { type: 'string' } },
			},
		}),
	)
	.withDefault({
		emailEnabled: false,
		emailSubjectLine: '',
		emailBody: [],
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'Starter dashboard email DM notification',
		description:
			'Currently English feature, US only. Determines whether to enable contact DM notification of the starter dashboard, and the subject/body copy (with %{dmName}, %{ask}, %{signatureCount}, %{petitionUrl}, %{starterDisplayName} placeholders) used to pre-fill it',
		import: false,
		template: {
			emailEnabled: false,
			emailSubjectLine: 'Subject line here',
			emailBody: ['Dear DM', 'Please respond', 'Best regards'],
		},
	});
